<template>
  <sn-select
    v-model="selectedItems"
    :placeholder="placeholder"
    multiple
    attach
    :disabled="disabled"
    :items="items"
  >
    <template
      v-slot:item="data"
    >
      <v-icon
        v-if="selectedItems.includes(data.item)"
        style="margin-right: 12px"
        color="#003a5d"
      >
        {{ '$snCheckBoxSelected' }}
      </v-icon>
      <v-icon
        v-else
        style="margin-right: 12px"
      >
        {{ '$snCheckBox' }}
      </v-icon>
      <span class="item-font">{{ data.item }}</span>
    </template>
  </sn-select>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'EnvSelect',
  props: {
    items: {
      type: Array,
      default: () => [],
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    value: {
      type: [String, Number, Array],
      default: '',
      required: false
    },
    placeholder: {
      type: String,
      default: 'Select environments this user can access',
      required: false
    }
  },
  data () {
    return {
      selectedItems: null
    }
  },
  watch: {
    value (newVal) {
      this.selectedItems = newVal
    },
    selectedItems (newVal) {
      this.$emit('input', this.selectedItems)
    }
  },
  created () {
    this.selectedItems = this.value
    this.options = _.cloneDeep(this.items)
  }
}
</script>

<style lang="scss" scoped>
@import '~/assets/css/snui';
.item-font {
  font-family: "Open Sans", sans-serif !important;
}
</style>
